/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-return-assign */
import HelpVideoModal from 'components/molecules/help_video_modal';
import React, { useState } from 'react';
import ThumbTutorial from 'components/atoms/thumb_tutorial';
import { TutorialDataKey, tutorialsData } from 'components/atoms/open_tutorial/tutorials';

const DrLicitaTutorial = () => {
  const [modalVideoOpened, setModalVideoOpened] = useState<boolean>(false);
  const [urlVideo, setUrlVideo] = useState<string>('');
  const source = 'drlicita';

  const tutorialsList = tutorialsData[source as TutorialDataKey];

  const handleOpenModal = (url: string) => {
    setUrlVideo(url);
    setModalVideoOpened(true);
  };

  return (
    <>
      <div className="row">
        {tutorialsList.map((item) => (
          <div className="col-4" key={item.video}>
            <div className="card p-3 h-100">
              <h5 className="mb-3">{item.title}</h5>
              <ThumbTutorial video={item.video} img={item.thumb} onClick={handleOpenModal} />
            </div>
          </div>
        ))}
      </div>

      <HelpVideoModal
        modalVideoOpened={modalVideoOpened}
        setModalVideoOpened={setModalVideoOpened}
        urlVideo={urlVideo}
      />
    </>
  );
};
export default DrLicitaTutorial;
